import { l } from '../lib/imports'
import { common } from '../main/common-sidecar'
import { IRawFrameInfo } from '../main/frameInfo'
import { frameInfo } from '../main/frameInfo-sidecar'
import { scene } from '../main/scene-sidecar'
import { spriteMap } from '../main/spriteMap-sidecar'
import { IStevieText } from './stevieText'
import { stevieText } from '../uiParts/stevieText-sidecar'
import { IEntity } from '../entities/entitiesUtils'
import { entitiesUtils } from '../entities/entitiesUtils-sidecar'
import { phaserUtil } from '../engine/phaserUtil-sidecar'
import { clickEater } from '../uiParts/clickEater-sidecar'

export interface IButton extends IEntity {
  // image: Phaser.GameObjects.Image
  text: IStevieText
  imageBackground: Phaser.GameObjects.Image
  isOver: boolean
  isMouseDown: boolean
  isMouseRightDown: boolean

  isSelected: boolean

  frames: IRawFrameInfo[]

  onClick: () => void
}

const objs: IButton[] = []

let w = 50
let h = 10
export const defaultFrames: IRawFrameInfo[] = [
  frameInfo.fiRaw(4, 2, 2, w, h),
  frameInfo.fiRaw(4, 2, 2 + h + 2, w, h),
  frameInfo.fiRaw(4, 2, 2 + 2 + 2 + h + h, w, h),
  // disabled: frameInfo.fi32(1, 5, 10),
  // bought: frameInfo.fi32(1, 5, 11),
]
export const closeFrames: IRawFrameInfo[] = [
  frameInfo.fiRaw(4, 2 + w + 2, 2, h, h),
  frameInfo.fiRaw(4, 2 + w + 2, 2 + h + 2, h, h),
  frameInfo.fiRaw(4, 2 + w + 2, 2 + 2 + 2 + h + h, h, h),
  // disabled: frameInfo.fi32(1, 5, 10),
  // bought: frameInfo.fi32(1, 5, 11),
]

export function create(
  layer: Phaser.GameObjects.Container,
  x: number,
  y: number,
  text: string,
  onClick: () => void,
  frames: IRawFrameInfo[] = defaultFrames,
) {
  let imageBackground = spriteMap.createImageFromRawFrameInfo(
    layer,
    frames[0] || defaultFrames[0],
    x,
    y,
    4,
  )

  let _text = stevieText.create(scene.getContext().font16, x + 10 + 4, y + 10)
  stevieText.setText(_text, text)

  let obj: IButton = {
    eType: 'button',
    id: common.createId(),
    imageBackground,
    isMouseDown: false,
    isMouseRightDown: false,
    isOver: false,
    text: _text,
    frames,
    onClick,
    isDead: false,
    isSelected: false,
  }
  objs.push(obj)

  phaserUtil.setInteractive(imageBackground)

  imageBackground.on('pointerover', () => {
    obj.isOver = true
  })
  imageBackground.on('pointerout', () => {
    obj.isOver = false
    obj.isMouseDown = false
  })

  imageBackground.on('pointerdown', () => {
    clickEater.tempEat()

    let scene = common.getPhaserScene()
    if (scene.game.input.activePointer.rightButtonDown()) {
      obj.isMouseRightDown = true
    } else {
      obj.isMouseDown = true
    }
  })
  imageBackground.on('pointerup', () => {
    clickEater.tempEat()

    if (obj.isMouseDown) {
      obj.isMouseDown = false
      if (obj.imageBackground.visible) {
        obj.onClick()
      }
    }
    if (obj.isMouseRightDown) {
      obj.isMouseRightDown = false
    }
  })
  return obj
}

export function setSelected(obj: IButton, isSelected: boolean) {
  obj.isSelected = isSelected
}

export function setVisible(obj: IButton, visible: boolean) {
  obj.imageBackground.visible = visible
  stevieText.setVisible(obj.text, visible)
}

export function kill(obj: IButton) {
  obj.isDead = true
}

export function updateAll() {
  l.forEach(objs, (c) => {
    update(c)
  })
  entitiesUtils.removeDead(objs, (c) => {
    c.imageBackground.destroy()
    stevieText.kill(c.text)
  })
}

export function update(obj: IButton) {
  if (obj.isMouseDown || obj.isSelected) {
    spriteMap.setRawFrame(
      obj.imageBackground,
      obj.frames[2] || defaultFrames[2],
      0,
      0,
    )
  } else if (obj.isOver) {
    spriteMap.setRawFrame(
      obj.imageBackground,
      obj.frames[1] || defaultFrames[1],
      0,
      0,
    )
  } else {
    spriteMap.setRawFrame(
      obj.imageBackground,
      obj.frames[0] || defaultFrames[0],
      0,
      0,
    )
  }
}
